import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuUtilService } from '@core/services/util/menu-util.service';

@Component({
    selector: 'app-pass-strip',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './pass-strip.component.html',
    styleUrls: ['./pass-strip.component.scss']
})
export class PassStripComponent implements OnChanges {
    @Input() product: any;
    @Input() passModel: any;
    @Input() deployUrl = '';

    shouldShowPassStrip = false;
    originalPrice = 0;
    passPrice = 0;

    constructor(private menuUtil: MenuUtilService) {}

    ngOnChanges() {
        this.updateProperties();
    }

    updateProperties() {
        const productId = this.product?.id;
        const passData = this.passModel?.[productId];

        this.passPrice = passData?.price || 0;
        this.shouldShowPassStrip = Boolean(passData?.has_pass && !passData?.is_applied && this.passPrice);
    }

    onStripClick() {
        this.menuUtil.openProductPassesModal();
    }
}
